import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import zh_CN from 'vee-validate/dist/locale/zh_CN'
import { verify } from '@/utils'

// 配置中文
Validator.addLocale(zh_CN)

const config = {
  locale: 'zh_CN'
};

Vue.use(VeeValidate, config)

// 自定义validate
const dictionary = {
  zh_CN: {
    messages: {
      email: () => '请输入正确的邮箱格式',
      required: ( field ) => {
        // return field
        switch (field) {
          case '名字很重要':
            return '名字很重要'
            break;
          case 'Pick一些关键词/标签':
            return 'Pick一些关键词/标签'
            break;
          case '告诉我们你在哪':
            return '告诉我们你在哪'
            break;
          case '开放还是私密':
            return '请选择' + field
            break;
          case '请上传图片':
            return '请上传图片'
            break;
          case '说了才有可能拿到50000元':
            return '说了才有可能拿到50000元'
            break;
          case '只有你说出来，我们才能更好地帮你':
            return '只有你说出来，我们才能更好地帮你'
            break;
          case '仔细想想':
            return '仔细想想'
            break;
          case '发动重造力，说出你的主题':
            return '发动重造力，说出你的主题'
            break;
          case '告诉我们你想怎么重造派对':
            return '告诉我们你想怎么重造派对'
            break;
          case '阐述你的重造计划':
            return '阐述你的重造计划'
            break;
          case '说明你的重造计划的环保意义':
            return '说明你的重造计划的环保意义'
            break;
          case '你希望绝对伏特加能给你怎样的支持？':
            return '你希望绝对伏特加能给你怎样的支持？'
            break;
          case '¥50,000赏金怎么花？':
            return '¥50,000赏金怎么花？'
            break;
          case '你的重造派对想办多大？':
            return '你的重造派对想办多大？'
            break;
          default:
            return '请输入' + field
        }
      }
    },
    attributes:{
      email:'邮箱',
      password:'密码',
      username: '姓名',
      smscode: '短信验证码',
      phone: '手机号码',
      userName: '名字很重要',
      userPhone: '手机号码',
      title: '你的夜计划标题',
      subTitle: '夜计划简介',
      tags: 'Pick一些关键词/标签',
      province: '告诉我们你在哪',
      city: '告诉我们你在哪',
      description: '简介',
      isPublic: '开放还是私密',
      wechat: '微信ID或手机号码',
      pictures: '请上传图片',
      note: '说了才有可能拿到50000元',
      support: '只有你说出来，我们才能更好地帮你',
      theme: '仔细想想',
      number: '夜计划规模',
      rebuildTitle: '发动重造力，说出你的主题',
      rebuildDescription: '告诉我们你想怎么重造派对',
      new_meaning: '阐述你的重造计划',
      signification: '说明你的重造计划的环保意义',
      influence: '你希望绝对伏特加能给你怎样的支持？',
      plan: '¥50,000赏金怎么花？',
      rebuildNumber: '你的重造派对想办多大？'
    }
  }
}

Validator.updateDictionary(dictionary)

Validator.extend('phone', {
  messages: {
    zh_CN: field => field + '格式不正确',
  },
  validate: value => {
    return verify.isPhone(value)
  }
})

Validator.extend('number', {
  messages: {
    zh_CN: field => field + '格式不正确',
  },
  validate: value => {
    return /^\d+$/.test(value)
  }
})



// WEBPACK FOOTER //
// ./src/assets/javascripts/validate.js